// components
import Directory from '../components/Directory';

const Home = () => {
  return <Directory />;
};

export default Home;
